// extracted by mini-css-extract-plugin
export default {"content":"StoryTellerContent_content__GbryW","items":"StoryTellerContent_items__oPeSS"};